var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#040517",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3255 21.1847H28.1096C28.0243 20.7112 27.8657 20.2945 27.6337 19.9347C27.4017 19.5748 27.1176 19.2694 26.7814 19.0185C26.4453 18.7675 26.0688 18.5781 25.6522 18.4503C25.2402 18.3224 24.8023 18.2585 24.3382 18.2585C23.5002 18.2585 22.7497 18.4692 22.0868 18.8906C21.4287 19.312 20.9078 19.9299 20.5243 20.7443C20.1455 21.5587 19.9561 22.553 19.9561 23.7273C19.9561 24.911 20.1455 25.91 20.5243 26.7244C20.9078 27.5388 21.431 28.1544 22.0939 28.571C22.7568 28.9877 23.5025 29.196 24.3311 29.196C24.7904 29.196 25.226 29.1345 25.638 29.0114C26.0546 28.8835 26.431 28.6965 26.7672 28.4503C27.1034 28.2041 27.3875 27.9034 27.6195 27.5483C27.8562 27.1884 28.0196 26.7765 28.1096 26.3125L30.3255 26.3196C30.2071 27.0346 29.9775 27.6927 29.6365 28.294C29.3004 28.8906 28.8671 29.4067 28.3368 29.8423C27.8113 30.2732 27.2099 30.607 26.5328 30.8438C25.8558 31.0805 25.1171 31.1989 24.3169 31.1989C23.0575 31.1989 21.9353 30.9006 20.9505 30.304C19.9656 29.7027 19.1891 28.8433 18.6209 27.7259C18.0575 26.6084 17.7757 25.2756 17.7757 23.7273C17.7757 22.1742 18.0598 20.8414 18.628 19.7287C19.1962 18.6113 19.9727 17.7543 20.9576 17.1577C21.9424 16.5563 23.0622 16.2557 24.3169 16.2557C25.0887 16.2557 25.8084 16.367 26.476 16.5895C27.1484 16.8073 27.7521 17.1293 28.2871 17.5554C28.8221 17.9768 29.2649 18.4929 29.6152 19.1037C29.9656 19.7098 30.2024 20.4034 30.3255 21.1847Z",
    fill: "#040517"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAvatar);
export default __webpack_public_path__ + "static/media/email-avatar.3b7532cdb5d842929f83735c5cbf6c49.svg";
export { ForwardRef as ReactComponent };